import React, { useMemo } from 'react';
import { useArtifactPanel } from '@cotera/client/v0/chat/artifact-panel-context';
import { ResourcePageShellBackButton } from '../../resources/resource-page-shell';

/**
 * Back control for resource pages rendered inside an artifact panel stack
 * (e.g. an agent opened from a workflow node). Returns `undefined` when the
 * page is the root artifact view.
 */
export function useArtifactPanelBackLeading(): React.ReactNode {
  const artifactPanel = useArtifactPanel();

  return useMemo(() => {
    if (artifactPanel?.canPopView !== true) {
      return undefined;
    }
    return (
      <ResourcePageShellBackButton onClick={() => artifactPanel.popView()} />
    );
  }, [artifactPanel]);
}
